"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSentry = exports.attachmentUrlFromDsn = void 0;
const tracing_1 = require("@sentry/tracing");
const isEnvironmentWithSentry = (env) => {
    return Boolean(env === null || env === void 0 ? void 0 : env.sentry);
};
const attachmentUrlFromDsn = (dsn, eventId) => {
    const { host, path, projectId, port, protocol, publicKey } = dsn;
    return `${protocol}://${host}${port ? `:${port}` : ''}${path ? `/${path}` : ''}/api/${projectId}/events/${eventId}/attachments/?sentry_key=${publicKey}&sentry_version=7&sentry_client=custom-javascript`;
};
exports.attachmentUrlFromDsn = attachmentUrlFromDsn;
/**
 * method to be used in the angular main.ts for
 */
const initSentry = ({ sentry, environmentName, environmentVariables, release, tags, debug, integrations, initOptions, }) => {
    if (!isEnvironmentWithSentry(environmentVariables)) {
        return;
    }
    const sentrySettings = environmentVariables.sentry;
    // make sure that tracing is patched and not tree-shaked
    // eslint-disable-next-line deprecation/deprecation
    (0, tracing_1.addExtensionMethods)();
    sentry.init(Object.assign(Object.assign({}, initOptions), { dsn: sentrySettings.dsn, environment: environmentName, tunnel: sentrySettings.tunnel, release,
        integrations, 
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: sentrySettings.tracesSampleRate, debug }));
    sentry.setTags(tags);
};
exports.initSentry = initSentry;
//# sourceMappingURL=init-sentry.js.map